/**
 * El catálogo de referencias de estilo para «Generar planta render».
 *
 * Una referencia es un PNG que viaja como SEGUNDA imagen al motor. La primera
 * —la planta rasterizada— manda la geometría; la segunda, sólo la apariencia.
 *
 * ⚠️ **Una referencia que sea una lámina COMPLETA no se usa como paleta: se
 * calca.** Medido el 14-oct-2026 con cuatro corridas sobre el mismo Burgos T.
 * Con la referencia de Lumion puesta, `gpt-image-1` copió su cochera, sus dos
 * autos (el blanco y el azul, idénticos), su acera, sus palmeras y su jardín de
 * yucas — nada de eso existe en la planta, y el prompt pide explícitamente no
 * inventar accesos ni estacionamientos. Sin referencia, la misma base salió
 * limpia y fiel. Por eso «Sin referencia» es una opción de primera clase y no
 * un modo degradado: hoy es la que respeta la planta.
 *
 * Agregar una referencia = soltar el PNG (y su `.thumb.jpg`) en
 * `public/estilos-render/` y escribir una línea acá. No hay manifiesto que
 * sincronizar ni fetch extra: el catálogo es chico y vive con el código que lo
 * usa.
 */
export type EstiloRender = {
  id: string;
  nombre: string;
  /** Qué esperar de esta referencia, en una línea, para el que elige. */
  nota: string;
  /** `null` = no se manda segunda imagen; el estilo lo describe el prompt. */
  url: string | null;
  miniatura: string | null;
};

export const ESTILOS_RENDER: EstiloRender[] = [
  {
    id: 'lumion',
    nombre: 'Lumion',
    nota: 'El look de las láminas de la oficina. Tiende a copiarle el lote y los autos.',
    url: '/estilos-render/lumion.png',
    miniatura: '/estilos-render/lumion.thumb.jpg',
  },
  {
    id: 'mnml',
    nombre: 'mnml',
    nota: 'Más plano y claro. También arrastra cochera y jardín propios.',
    url: '/estilos-render/mnml.png',
    miniatura: '/estilos-render/mnml.thumb.jpg',
  },
  {
    id: 'ninguna',
    nombre: 'Sin referencia',
    nota: 'El estilo lo describe el prompt. Es la que mejor respeta la planta.',
    url: null,
    miniatura: null,
  },
];

/** La que viene marcada al abrir. Decisión de Daniel (14-oct-2026). */
export const ESTILO_POR_DEFECTO = 'lumion';
